import { NavbarJourney } from "../Navbar/NavbarJourney";
export const PayHeader = () => {
  return (<NavbarJourney />);
};
